@if (showPinnedFilters) {
  @for (filter of (pinnedUserFilters$ | async); track filter) {
    <sk-button-group>
      <sk-button
        [attr.data-test]="'module-filter-' + filter.name + '-button'"
        [label]="filter.name | irisTranslate: filter.translations?.name"
        (click)="applyCustomFilter(filter.filter)">
      </sk-button>
      <sk-button
        [attr.data-test]="'module-unpinFilter-' + filter.name + '-button'"
        [suppressMinWidth]="true"
        [padded]="'sm'"
        [matTooltip]="'label.mf.UnpinFilter' | translate"
        (click)="pinCustomFilter(filter, false)"
        (mouseover)="hoverFilterId = filter.id"
        (mouseleave)="hoverFilterId = null">
        <ng-template buttonPrefix>
          <i [class]="hoverFilterId === filter.id ? 'icon fa-fw far fa-fw fa-times' : 'icon fa-fw fas fa-fw fa-thumbtack'"></i>
        </ng-template>
      </sk-button>
    </sk-button-group>
  }
}
@if (showFilterMenu) {
  <sk-button-group>
    <sk-button
      data-test="set-filter"
      [label]="(showTitle ? 'label.Filter' : '') | translate"
      (click)="toggleFilterVisibility()"
      [suppressMinWidth]="true"
      [matTooltip]="'label.dms.SetFilter' | translate">
      <ng-template buttonPrefix>
        <i class="icon fa-fw fas fa-filter"></i>
      </ng-template>
    </sk-button>
    @if (resetButton) {
      <sk-button
        data-test="reset-filters"
        (click)="resetFilterToDefault()"
        [matTooltip]="'label.ResetFilter' | translate">
        <ng-template buttonPrefix>
          <i class="icon far fa-fw fa-times"></i>
        </ng-template>
      </sk-button>
    }
    <sk-button
      data-test="saved-filters"
      [suppressMinWidth]="true"
      [padded]="'sm'"
      [matMenuTriggerFor]="menu"
      (click)="toggleMenuVisibility()"
      [matTooltip]="'label.dms.SavedFilters' | translate">
      <ng-template buttonPrefix>
        <i class="icon far fa-chevron-down fa-fw"></i>
      </ng-template>
    </sk-button>
  </sk-button-group>

  <mat-menu class="tools_dropdown"
            #menu="matMenu"
            [overlapTrigger]="false">
    @if (shouldShowNoFilters$ | async) {
      <div class="filtr-dd">
        <div class="mf-empty-filter-list-placeholder">{{'label.mf.NoSavedFilters' | translate}}</div>
      </div>
    }
    @if (shouldShowRecentlyUsed$ | async) {
      <div class="filtr-dd__bl">
        <div class="filtr-dd__bl-ttl">{{'label.RecentlyUsed' | translate}}</div>
        <div class="filtr-dd__bl-cnt">
          <ul>
            @for (filter of (recentFilters$ | async); track filter) {
              <li (click)="applyCustomFilter(filter.filter)">
                <div class="i-checkbox"></div>
                <span>{{ filter.name | irisTranslate: filter.translations?.name }}</span>
              </li>
            }
          </ul>
        </div>
      </div>
    }
    @if (shouldShowSaved$ | async) {
      <div class="filtr-dd__bl">
        <div class="filtr-dd__bl-ttl">{{'label.SavedFilters' | translate}}</div>
        <div class="filtr-dd__bl-cnt">
          <ul>
            @for (filter of (userFilters$ | async); track filter) {
              <li (click)="applyCustomFilter(filter.filter)">
                <div class="i-checkbox"></div>
                <span class="filtr-dd__name saved">{{ filter.name | irisTranslate: filter.translations?.name }}</span>
                <div class="filtr-dd__btns">
                  <sk-button size="sm"
                             appearance="icon"
                             class="filtr-dd__btn"
                             clickStopPropagation
                             [matTooltip]="'label.RewriteFilter' | translate"
                             (click)="updateUserFilter(filter)">
                    <ng-template buttonPrefix>
                      <i class="far icon fa-save filtr-dd__ico"></i>
                    </ng-template>
                  </sk-button>
                  <sk-button size="sm"
                             appearance="icon"
                             class="filtr-dd__btn"
                             clickStopPropagation
                             [matTooltip]="'label.EditFilter' | translate"
                             (click)="editUserFilter(filter)">
                    <ng-template buttonPrefix>
                      <i class="fas icon fa-pencil-alt filtr-dd__ico"></i>
                    </ng-template>
                  </sk-button>
                  <sk-button size="sm"
                             appearance="icon"
                             class="filtr-dd__btn"
                             clickStopPropagation
                             [matTooltip]="'label.RemoveFilter' | translate"
                             (click)="removeUserFilter(filter)">
                    <ng-template buttonPrefix>
                      <i class="fas icon fa-trash filtr-dd__ico"></i>
                    </ng-template>
                  </sk-button>
                  <sk-button
                    [suppressMinWidth]="true"
                    [padded]="'sm'"
                    size="sm"
                    appearance="icon"
                    class="filtr-dd__btn"
                    clickStopPropagation
                    [matTooltip]="(filter.isPinned? 'label.mf.UnpinFilter' : 'label.mf.PinFilter') | translate"
                    placement="top-right"
                   (click)="pinCustomFilter(filter, !filter.isPinned)">
                    <ng-template buttonPrefix>
                      <i class="fa-fw icon" [class]="filter.isPinned? 'far fa-times' : 'fas fa-thumbtack'"></i>
                    </ng-template>
                  </sk-button>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    }
  </mat-menu>
}
